<template>
  <div class="ttshop_user">
    <Header></Header>
    <Userheader></Userheader>
    <div class="ttshop_user">
      <div class="ttshop_usercon w clearfloat">
        <!-- 个人中心导航 -->
        <Usernavleft></Usernavleft>
        <div class="ttshop_useright">
          <!-- 我的收藏 -->
          <div class="ttshop_coupon min_h">
            <!-- 暂无收藏商品时显示 -->
            <div class="ttshop_zwsc">
              <img
                class="img-default"
                src="../../assets/images/ttshop_sc.png"
                alt=""
              />
              <p>暂无收藏商品</p>
            </div>
            <!-- 收藏商品列表 -->
            <div class="ttshop_collection clearfloat">
              <div
                class="ttshop_collectionlist"
                v-for="(item, index) in shoplist"
                :key="index"
                @click="goodsdeta(item.goods_id)"
              >
                <div class="ttshop_collectionimg">
                  <img
                    class="img-default ttshop_collecimg"
                    :src="item.goods_pic"
                    alt=""
                  />
                  <div class="ttshop_gmqx clearfloat">
                    <button class="ttshop_join" @click.stop="jiarugpuwu(item)">
                      <i
                        ><img
                          class="img-default"
                          src="../../assets/images/ttshop_addshop.png"
                          alt=""
                      /></i>
                      加入购物车
                    </button>
                    <button
                      class="ttshop_removeshop"
                      @click.stop="cancelcoll(item.goods_id)"
                    >
                      取消收藏
                    </button>
                  </div>
                </div>
                <!-- <div  :class="['ttshop_collcon','ttshop_collcon'+index]">
									<div class="ttshop_collconter swiper-container swiper-no-swiping" >
										<ul class="clearfloat swiper-wrapper">
											<li class="swiper-slide"><img class="img-default" src="../../assets/images/goods_1.png" alt="" ></li>
											<li class="swiper-slide"><img class="img-default" src="../../assets/images/goods_1.png" alt="" ></li>
											<li class="swiper-slide"><img class="img-default" src="../../assets/images/goods_1.png" alt="" ></li>
											<li class="swiper-slide"><img class="img-default" src="../../assets/images/goods_1.png" alt="" ></li>
											<li class="swiper-slide"><img class="img-default" src="../../assets/images/goods_1.png" alt="" ></li>
											<li class="swiper-slide"><img class="img-default" src="../../assets/images/goods_1.png" alt="" ></li>
											<li class="swiper-slide"><img class="img-default" src="../../assets/images/goods_1.png" alt="" ></li>
										</ul>
									</div> -->
                <!-- 左右箭头 -->
                <!-- <div class="swiper-button-prev ttshop_prev"></div>
									<div class="swiper-button-next ttshop_next"></div>
								</div> -->
                <div class="ttshop_collbut">
                  <h5>￥ {{ item.price }}</h5>
                  <p class="ttshop_shopname">{{ item.name }}</p>
                  <!-- <div class="ttshop_colltext clearfloat">
										<div class="ttshop_colltextleft">
											<p><span>50</span>评价</p>
										</div>
										<div class="ttshop_colltextright">
											<p><span>100%</span>好评</p>
										</div>
									</div> -->
                  <div class="clearfloat ttshop_collbutton" v-if="item.service">
                    <p v-for="(i, b) in item.service" :key="b">{{ i }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="ttshop_myorderpage clearfloat">
              <el-pagination
                class="ttshop_pages"
                background
                layout="prev, pager, next"
                :total="row_count"
                @prev-click="pages_perv"
                @next-click="page_next"
                @current-change="pageChange"
                :page-count="page_count"
                :hide-on-single-page="page_type"
              ></el-pagination>
            </div>
            <el-dialog
              title="商品规格"
              :visible.sync="dialogTableVisible"
              center
            >
              <div class="specifications">
                <div
                  class="group_list"
                  v-for="(item, index) in shopdetail.attr_group_list"
                  :key="index"
                >
                  <div class="board_name">{{ item.attr_group_name }}</div>
                  <div class="gaugegroup">
                    <div v-for="(i, b) in item.attr_list" :key="b">
                      <div class="items" v-if="i.attr_num_0">
                        {{ i.attr_name }}
                      </div>
                      <div
                        class="item d-flex justify-content-center align-items-center"
                        @click="sizeClick(item.attr_group_id, i.attr_id)"
                        :class="{ size_active: i.active == true }"
                        v-else
                      >
                        {{ i.attr_name }}
                        <div class="pitc" v-if="i.active">
                          <img
                            class="img-default"
                            src="../../assets/images/brand.png"
                            alt
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 数量 -->
                <div class="num d-flex align-items-center">
                  <div class="num-name">数量</div>
                  <el-input-number
                    v-model="num"
                    @change="handleChange"
                    :min="1"
                    :max="shopdetail.vr_type == 1 ? 1 : ttshop_kcnum"
                    label="描述文字"
                  ></el-input-number>
                </div>
                <div
                  slot="footer"
                  class="dialog-footer btn d-flex align-items-center"
                >
                  <div
                    class="btn-buy d-flex justify-content-center align-items-center"
                    @click="goodsSubmit(2)"
                  >
                    立即购买
                  </div>
                  <div
                    class="btn-cat d-flex align-items-center justify-content-center"
                    @click="goodsSubmit(1)"
                    v-if="shopdetail.vr_type == 0"
                  >
                    <div class="btn-cat-img">
                      <img
                        class="img-default"
                        src="../../assets/images/cat_white.png"
                        alt
                      />
                    </div>
                    加入购物车
                  </div>
                  <div
                    class="btn-phone d-flex align-items-center justify-content-center"
                    v-if="false"
                  >
                    <div class="btn-phone-l">
                      <img
                        class="img-default"
                        src="../../assets/images/cat_white.png"
                        alt
                      />
                    </div>
                    手机购买
                    <div class="btn-phone-r">
                      <img
                        class="img-default"
                        src="../../assets/images/bottom_14.png"
                        alt
                      />
                    </div>
                    <div class="btn-phone-qr">
                      <div class="btn-phone-img"></div>
                    </div>
                  </div>
                </div>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>

<script>
import Header from "@/components/header/header";
import Foot from "@/components/foot/foot";
import Userheader from "./components/user_index";
import Usernavleft from "./components/user_navleft";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  inject: ['reload'],
  components: {
    Header,
    Userheader,
    Usernavleft,
    Foot,
  },
  data() {
    return {
      page: 0,
      shoplist: [],
      dialogTableVisible: false,
      shopdetail: "", //选中的商品
      num: 1,
      ttshop_kcnum: 1,
      goods_attr_info: {},
      ttshop_kucun: [],
      page_count:null,
      page_type:null,
      row_count:'',
    };
  },
  mounted() {
    this.collectshop();
    // 商品轮播
    for (let i = 0; i < 8; i++) {
      let element = ".ttshop_collcon" + i + " .ttshop_collconter";
      let nextEl = ".ttshop_collcon" + i + " .ttshop_next";
      let prevEl = ".ttshop_collcon" + i + " .ttshop_prev";
      let mySwiper = new Swiper(element, {
        loop: false, // 循环模式选项
        slidesPerView: 5,
        spaceBetween: 3,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
      });
    }
  },
  methods: {
    //获取商品数量
    collectshop() {
      this.$api
        .collshop({
          page: this.page,
        })
        .then((res) => {
          this.shoplist = res.data.list;
          this.data_type = true;
          this.page_count = res.data.page_count;
          this.row_count=res.data.row_count;
        })
        .catch((err) => {
          this.shoplist = [];
        });
    },
    //上一页
    pages_perv() {
      this.page--;
    },
    // 下一页
    page_next() {
      this.page++;
    },
    // 输入分页
    pageChange(e) {
      this.page = e;
      this.common.backTop();
      this.collectshop();
    },
    //获取数量
    handleChange(value) {singleAttr
      this.num = value;
    },
    //加入购物车
    jiarugpuwu(item) {
      this.shopdetail = item;
      this.singleAttr();
      this.ttshop_kucun = JSON.parse(item.attr);
      this.dialogTableVisible = true;
    },
    // 单属性自动选择
    singleAttr() {
      let that = this;
      let attr_group_list = that.shopdetail.attr_group_list;
      for (let i in attr_group_list) {
        for (let j in attr_group_list[i].attr_list) {
          that.$set(attr_group_list[i].attr_list[j], "active", false);
          that.$set(attr_group_list[i].attr_list[j], "attr_num_0", false);
        }
        if (attr_group_list[i].attr_list.length <= 1) {
          that.sizeClick(
            attr_group_list[i].attr_group_id,
            attr_group_list[i].attr_list[0].attr_id
          );
        }
      }
    },
    // 属性尺码
    sizeClick(groupid, attrid) {
      let attr_group = this.shopdetail.attr_group_list; //商品总属性
      let attr_group_id = groupid; //属性组id
      let attr_id = attrid; //属性id
      let ativerattr = [];
      let attr = this.ttshop_kucun; //属性库存
      for (var i in attr_group) {
        if (attr_group[i].attr_group_id == attr_group_id) {
          for (var j in attr_group[i].attr_list) {
            // attr_group[i].attr_list[j].active =
            // attr_group[i].attr_list[j].attr_id == attr_id ? true : false;
            attr_group[i].attr_list[j].active =
              attr_group[i].attr_list[j].attr_id == attr_id
                ? !attr_group[i].attr_list[j].active
                : false;
          }
        }
      }
      for (var i in attr_group) {
        for (var j in attr_group[i].attr_list) {
          if (attr_group[i].attr_list[j].active) {
            ativerattr.push(attr_group[i].attr_list[j].attr_id);
          }
        }
      }
      var u = [],
        goods_attr_info = null;
      for (var n in attr) {
        var c = [],
          _ = 0;
        for (var d in attr[n].attr_list) {
          this.inArray(attr[n].attr_list[d].attr_id, ativerattr) || (_ += 1),
            c.push(attr[n].attr_list[d].attr_id);
        }
        0 === attr[n].num && _ <= 1 && u.push(c);
        if (ativerattr.toString() == c.toString()) {
          goods_attr_info = attr[n];
        }
      }
      var g = ativerattr.length,
        l = [];
      if (attr_group.length - g <= 1)
        for (var n in ativerattr)
          for (var d in u)
            if (this.inArray(ativerattr[n], u[d]))
              for (var f in u[d]) u[d][f] !== ativerattr[n] && l.push(u[d][f]);
      for (var n in attr_group)
        for (var d in attr_group[n].attr_list) {
          var m = attr_group[n].attr_list[d];
          this.inArray(m.attr_id, l) && !this.inArray(m.attr_id, ativerattr)
            ? (m.attr_num_0 = !0)
            : (m.attr_num_0 = !1);
        }

      this.check_attr_length = g;
      if (g == attr_group.length && goods_attr_info) {
        let goods_attr_name = "";
        for (let i in goods_attr_info.attr_list) {
          goods_attr_name += goods_attr_info.attr_list[i].attr_name + ";";
        }
        this.goods_attr_info = goods_attr_info;
        this.ttshop_kcnum = Number(goods_attr_info.num); //商品总库存
        this.goods_attr_name = goods_attr_name.substring(
          0,
          goods_attr_name.length - 1
        );
        if (goods_attr_info.pic) {
          this.ttshop_goodsxinxi.cover_pic = goods_attr_info.pic;
        }
      }
    },

    inArray: function (e, t) {
      return t.some(function (t) {
        return e === t;
      });
    },
    // 加入购物车和立即购买
    goodsSubmit(type) {
      if (this.shopdetail.is_negotiable == 1) {
        this.$message({
          showClose: true,
          message: "面议商品不可直接购买",
          type: "warning",
          offset: 200,
          duration: 1000,
        });
        return false;
      }
      //type = 1 加入购物车  type = 2 立即购买
      let attr_group = this.shopdetail.attr_group_list;
      let goods_num = this.goods_attr_info.num; //选择商品的库存
      if (this.check_attr_length != attr_group.length) {
        this.$message({
          showClose: true,
          message: "请选择商品属性",
          type: "warning",
          offset: 200,
          duration: 1000,
        });
        return false;
      }
      let attr = [];
      for (let i in attr_group) {
        for (let j in attr_group[i].attr_list) {
          if (attr_group[i].attr_list[j].active) {
            attr.push({
              attr_group_id: attr_group[i].attr_group_id,
              attr_id: attr_group[i].attr_list[j].attr_id,
              attr_name: attr_group[i].attr_list[j].attr_name,
            });
          }
        }
      }
      if (goods_num < this.num) {
        this.$message({
          showClose: true,
          message: "商品库存不足",
          type: "warning",
          offset: 200,
          duration: 1000,
        });
        return false;
      }
      if (type == 1) {
        let data = {
          goods_id: this.shopdetail.goods_id,
          attr: JSON.stringify(attr),
          num: this.num,
        };
        this.$api
          .shopcar(data)
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                showClose: true,
                message: res.msg,
                type: "success",
                offset: 200,
                duration: 1000,
              });
              this.dialogTableVisible = false;
              this.reload();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else if (type == 2) {
        let that = this;
        let mch_id = 0;
        let vr_type = 0;
        if (this.shopdetail.type == 3) {
          mch_id = "alibaba";
        }else if(this.shopdetail.type == 7){
           mch_id = "yzh";
        } else {
          if (this.shopdetail.mch) {
            mch_id = this.shopdetail.mch.id;
          } else if (this.shopdetail.mch_id) {
            mch_id = this.shopdetail.mch_id;
          }
        }

        if (this.shopdetail.vr_type >= 0) {
          vr_type = this.shopdetail.vr_type;
        }
        let mch_list = [
          {
            mch_id: mch_id,
            goods_list: [
              {
                goods_id: this.shopdetail.goods_id,
                attr: attr,
                num: this.num,
              },
            ],
          },
        ];
        if (this.$store.state.user) {
          if (this.$store.state.user.token != "") {
            let params = {
              mch_list: JSON.stringify(mch_list),
              vr_type: vr_type,
            };
            this.$store.commit("submitOrderRarams", params);
            this.$router.push({
              name: "submitOrder",
            });
          } else {
            this.$router.push({
              name: "signin",
              query: {
                redirect: this.$router.currentRoute.fullPath,
              },
            });
          }
        } else {
          this.$router.push({
            name: "signin",
            query: {
              redirect: this.$router.currentRoute.fullPath,
            },
          });
        }
      }
    },
    //前往商品的详情
    goodsdeta(id) {
      this.$router.push({
        path: "/pages/goods/goods",
        query: {
          id: id,
        },
      });
    },
    //取消收藏商品
    cancelcoll(id) {
      var that = this;
      this.$confirm("确认是否要取消收藏该商品", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          that.quxiaoshop(id);
        })
        .catch(() => {});
    },
    quxiaoshop(id) {
      this.$loading();
      let params = {
        goods_id: id,
      };
      var that = this;
      this.$api
        .favoriteRemove(params)
        .then((res) => {
          this.$loading().close();
          if (res.code == 0) {
            this.$message({
              showClose: true,
              message: "已取消收藏",
              type: "success",
              offset: 200,
              duration: 1000,
            });
            that.collectshop();
          }
        })
        .catch((err) => {
          this.common.message(this, err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
//规格 start
.specifications {
  .group_list {
    .board_name {
    }
    .gaugegroup {
      margin-top: 10px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      .items {
        cursor: no-drop;
        min-width: 35px;
        height: 34px;
        border-radius: 2px;
        border: 1px dashed #ccc;
        margin-right: 8px;
        padding: 0 12px;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 5px;
        opacity: 0.8;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .item {
        cursor: pointer;
        min-width: 35px;
        height: 34px;
        border-radius: 2px;
        border: 1px solid #ebebeb;
        margin-right: 8px;
        padding: 0 12px;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 5px;

        .pitc {
          position: absolute;
          bottom: 0;
          right: 0;
          height: 12px;
          width: 12px;
        }

        &:hover {
          border-color: #ff0e25;
        }
      }
    }
  }
  // 数量
  .num {
    margin-top: 16px;

    .num-name {
      width: 76px;
      color: #666666;
      padding-left: 12px;
      box-sizing: border-box;
    }
  }
  // 按钮
  .btn {
    margin-top: 24px;
    // margin-left: 76px;
    justify-content: center;
    .btn-buy {
      cursor: pointer;
      width: 112px;
      height: 40px;
      background: #ff0e25;
      border-radius: 2px;
      color: #fff;
      font-size: 16px;
      font-weight: 500;
    }

    .btn-cat {
      cursor: pointer;
      margin-left: 8px;
      width: 148px;
      height: 40px;
      background: rgba(255, 144, 16, 1);
      border-radius: 2px;
      font-weight: 500;
      font-size: 16px;
      color: #fff;

      .btn-cat-img {
        height: 16px;
        width: 16px;
        margin-right: 4px;
      }
    }

    .btn-phone {
      margin-left: 8px;
      width: 126px;
      height: 40px;
      border: 1px solid #ebebeb;
      border-radius: 2px;
      font-weight: 500;
      font-size: 12px;
      color: #666666;
      position: relative;
      box-sizing: border-box;
      overflow: hidden;
      cursor: pointer;

      &:hover {
        overflow: visible;
      }

      .btn-phone-l {
        height: 16px;
        width: 16px;
        background-color: #cccccc;
        margin-right: 8px;
      }

      .btn-phone-r {
        height: 14px;
        width: 14px;
        margin-left: 20px;
      }

      .btn-phone-qr {
        width: 126px;
        height: 114px;
        border: 1px solid #ebebeb;
        background-color: #fff;
        position: absolute;
        left: -1px;
        top: 38px;
        box-sizing: border-box;
        padding: 0 12px;
        border-top-color: #fff;

        .btn-phone-img {
          height: 102px;
          width: 102px;
          background-color: #ccc;
        }
      }
    }
  }
}
//end
.ttshop_coupon {
  width: 100%;
  background: #fff;
  padding: 20px 0 40px 0px;
  box-sizing: border-box;

  .ttshop_zwsc {
    width: 100%;
    padding-top: 200px;
    box-sizing: border-box;
    display: none;

    img {
      display: block;
      width: 85px;
      height: 80px;
      margin: 0 auto 20px;
    }

    p {
      font-size: 16px;
      color: #333;
      text-align: center;
    }
  }

  .ttshop_collection {
    width: 100%;
    .ttshop_collectionlist {
      float: left;
      width: 246px;
      background: #fff;
      padding: 12px;
      box-sizing: border-box;
      margin-right: 2px;
      margin-bottom: 20px;

      &:nth-child(4n) {
        margin-right: 0;
      }

      .ttshop_collectionimg {
        width: 100%;
        height: 222px;
        margin-bottom: 8px;
        position: relative;
        overflow: hidden;

        .ttshop_collecimg {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
          margin: 0 auto;
        }

        .ttshop_gmqx {
          width: 100%;
          height: 28px;
          background: #ff0e25;
          position: absolute;
          bottom: 0;
          left: -100%;
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;

          .ttshop_join {
            float: left;
            width: 148px;
            height: 28px;
            border: 0;
            outline: none;
            font-size: 12px;
            color: #fff;
            background: #ff0e25;
            cursor: pointer;

            i {
              display: inline-block;
              width: 16px;
              height: 16px;
              vertical-align: -3px;

              img {
                display: block;
                width: 100%;
              }
            }
          }

          .ttshop_removeshop {
            width: 73px;
            height: 26px;
            margin-top: 1px;
            margin-right: 1px;
            font-size: 12px;
            color: #ff0e25;
            border: 0;
            outline: none;
            cursor: pointer;
            background: #fff;
          }
        }

        &:hover .ttshop_gmqx {
          left: 0;
        }
      }

      .ttshop_collcon {
        width: 100%;
        padding: 0 19px;
        box-sizing: border-box;
        position: relative;
        margin-bottom: 12px;

        .ttshop_collconter {
          width: 100%;
          padding: 0 1px;
          box-sizing: border-box;
          ul {
            li {
              float: left;
              width: 32px;
              height: 32px;
              border: 1px solid #ebebeb;
              padding: 1px;
              box-sizing: border-box;
              transition: 0.5s;
              -moz-transition: 0.5s;
              -webkit-transition: 0.5s;
              -o-transition: 0.5s;

              &:hover {
                border-color: #ff0e25;
              }

              img {
                display: block;
                width: 28px;
                height: 28px;
                margin: 0 auto;
                object-fit: cover;
              }
              &:last-child {
                margin-right: 0 !important;
              }
            }
          }
        }

        .ttshop_prev {
          width: 14px;
          height: 14px;
          margin-top: -7px;
          background: url(../../assets/images/ttshop_scleft.png) center
            no-repeat;
          left: 0;
          cursor: pointer;
          z-index: 100;
          outline: none;
        }

        .ttshop_next {
          width: 14px;
          height: 14px;
          margin-top: -7px;
          background: url(../../assets/images/ttshop_scright.png) center
            no-repeat;
          right: 0;
          cursor: pointer;
          z-index: 100;
          outline: none;
        }
      }

      .ttshop_collbut {
        width: 100%;

        h5 {
          font-size: 20px;
          color: #ff4300;
          font-weight: bold;
          line-height: 20px;
          margin-bottom: 7px;
        }

        .ttshop_shopname {
          width: 100%;
          font-size: 12px;
          color: #666;
          font-weight: 400;
          line-height: 18px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          max-height: 36px;
          height: 36px;
          margin-bottom: 8px;
        }

        .ttshop_colltext {
          width: 100%;
          margin-bottom: 12px;

          .ttshop_colltextleft {
            float: left;

            p {
              font-size: 12px;
              color: #999;
              line-height: 12px;

              span {
                font-size: 12px;
                color: #0e9cff;
                margin-right: 4px;
              }
            }
          }

          .ttshop_colltextright {
            float: right;

            p {
              font-size: 12px;
              color: #999;
              line-height: 12px;

              span {
                font-size: 12px;
                color: #ff9010;
              }
            }
          }
        }

        .ttshop_collbutton {
          width: 100%;

          p {
            float: left;
            font-size: 12px;
            color: #ff0e25;
            border: 1px solid #ff0e25;
            border-radius: 3px;
            font-weight: 400;
            line-height: 12px;
            padding: 2px 4px;
            box-sizing: border-box;
            margin-right: 4px;
          }
        }
      }
    }
  }
  .ttshop_myorderpage {
    width: 100%;
    margin-top: 32px;
    .ttshop_pages {
      float: right;
    }
  }
}
</style>
